var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dropdown",
        { staticClass: "d2-mr", attrs: { size: "small", trigger: "click" } },
        [
          _c(
            "span",
            { staticClass: "btn-text" },
            [
              _vm.info.is_develop == 1
                ? [
                    _vm.info.enterprise.name || _vm.info.name
                      ? [
                          _c(
                            "span",
                            {
                              staticClass: "enterprise-link",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.handleClick($event)
                                }
                              }
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.info.enterprise.name) + " "
                              )
                            ]
                          ),
                          _vm.info.enterprise.status === 0
                            ? _c(
                                "el-tag",
                                {
                                  staticClass: "d2-ml-5",
                                  attrs: {
                                    type: "warning",
                                    size: "mini",
                                    effect: "plain"
                                  }
                                },
                                [_vm._v(" 待审批 ")]
                              )
                            : _vm._e(),
                          _vm.info.enterprise.status === 2
                            ? _c(
                                "el-tag",
                                {
                                  staticClass: "d2-ml-5",
                                  attrs: {
                                    type: "danger",
                                    size: "mini",
                                    effect: "plain"
                                  }
                                },
                                [_vm._v(" 被封禁 ")]
                              )
                            : _vm._e(),
                          _c("span", [
                            _vm._v(" " + _vm._s("你好 " + _vm.info.name || ""))
                          ])
                        ]
                      : [_vm._v(" 欢迎 ")]
                  ]
                : _vm.info.is_develop == 2
                ? [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.info.name ? "你好 " + _vm.info.name : "欢迎"
                        ) +
                        " "
                    )
                  ]
                : [_vm._v(" 欢迎 ")]
            ],
            2
          ),
          _c(
            "el-dropdown-menu",
            { attrs: { slot: "dropdown" }, slot: "dropdown" },
            [
              _c(
                "el-dropdown-item",
                {
                  nativeOn: {
                    click: function($event) {
                      return _vm.logOff($event)
                    }
                  }
                },
                [
                  _c("d2-icon", {
                    staticClass: "d2-mr-5",
                    attrs: { name: "power-off" }
                  }),
                  _vm._v(" 退出登录 ")
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("showAppList", { ref: "showAppList" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }